import { Link } from "react-router-dom";

const siteNav = [
  { label: "首页", to: "/" },
  { label: "热门主角", to: "/renwu" },
  { label: "走红大事记", to: "/shijian" },
  { label: "关于我们", to: "/about" },
];

const typeLinks = [
  { label: "才艺破圈", to: "/renwu" },
  { label: "手作非遗", to: "/renwu" },
  { label: "职业达人", to: "/renwu" },
  { label: "萌宠治愈", to: "/renwu" },
  { label: "表达共鸣", to: "/renwu" },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">吃瓜爆网</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-700">
              专注追踪新晋网红与爆红人物的走红事件与热门主角，从素人到顶流的出圈之路全记录。见证每一个认真生活的人，如何被世界看见。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://x.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                aria-label="X 社交平台"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-twitter-x-fill" aria-hidden="true" />
              </a>
              <a
                href="https://www.douyin.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                aria-label="抖音"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-video-line" aria-hidden="true" />
              </a>
              <a
                href="https://www.bilibili.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                aria-label="B站"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-play-circle-line" aria-hidden="true" />
              </a>
              <a
                href="https://weibo.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
              >
                <i className="ri-weibo-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950">站点导航</h4>
            <ul className="mt-4 space-y-3">
              {siteNav.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950">追更栏目</h4>
            <ul className="mt-4 space-y-3">
              {typeLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 吃瓜爆网 · 走红事件追踪 · 内容仅供资讯参考
          </p>
          <p className="text-xs text-foreground-600">联系邮箱：contact@chiguabaowang.example</p>
        </div>
      </div>
    </footer>
  );
}